module.exports = __webpack_public_path__ + "static/media/icon_formalities.eddd0535.svg";